export function isFalsyOrWhiteSpaceOnly(
  value: unknown,
): value is null | undefined | string {
  return (
    value === undefined ||
    value === null ||
    (typeof value === 'string' && value.trim() === '')
  );
}
